import { css as t, ct as n } from "@/styled-system/css";
const r = t.raw({
  color: "inherit",
  flex: "0 0 auto",
  marginInlineStart: n("Banner.spacing.gap.text-toActions.horz")
});
export {
  r as bannerActionRecipe
};
//# sourceMappingURL=banner-action.styles.js.map
